import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '../components/auth/ProtectedRoute';
import PublicRoute from '../components/auth/PublicRoute';

// Layouts
import AdminLayout from '../layouts/AdminLayout';
import SupervisorLayout from '../layouts/SupervisorLayout';
import PostulanteLayout from '../layouts/PostulanteLayout';
import JefeSeleccionLayout from '../layouts/JefeSeleccionLayout';
import AnalistaLayout from '../layouts/AnalistaLayout';
import ReclutadorLayout from '../layouts/ReclutadorLayout';

// Auth Pages
import Login from '../pages/auth/Login';

// Admin Pages
import AdminDashboard from '../pages/admin/Dashboard';
import Procesos from '../pages/admin/Procesos';
import Perfiles from '../pages/admin/Perfiles';
import Examenes from '../pages/admin/Examenes';
import AdminExamenesRaven from '../pages/supervisor/ExamenesRaven';
import AdminExamenesDisc from '../pages/supervisor/ExamenesDisc';
import AdminExamenesIpv from '../pages/admin/ExamenesIpv';
import GestionarExamen from '../pages/admin/GestionarExamen';
import Preguntas from '../pages/admin/Preguntas';
import Opciones from '../pages/admin/Opciones';
import Usuarios from '../pages/admin/Usuarios';
import Asignaciones from '../pages/admin/Asignaciones';
import AsignarPostulantesAdmin from '../pages/admin/AsignarPostulantesAdmin';
import AdminPerfilPruebas from '../pages/admin/PerfilPruebas';
import AdminRevisionExamen from '../pages/admin/RevisionExamen';
import AdminRevisionExamenIpv from '../pages/admin/RevisionExamenIpv';
import ResultadosIpv from '../pages/admin/ResultadosIpv';
import AdminProcesoDetalle from '../pages/admin/ProcesoDetalle';

// Supervisor Pages
import SupervisorDashboard from '../pages/supervisor/Dashboard';
import AsignarPostulantes from '../pages/supervisor/AsignarPostulantes';
import SupervisorProcesos from '../pages/supervisor/Procesos';
import SupervisorPerfiles from '../pages/supervisor/Perfiles';
import SupervisorExamenes from '../pages/supervisor/Examenes';
import SupervisorExamenesRaven from '../pages/supervisor/ExamenesRaven';
import SupervisorExamenesDisc from '../pages/supervisor/ExamenesDisc';
import SupervisorExamenesIpv from '../pages/supervisor/ExamenesIpv';
import SupervisorResultadosIpv from '../pages/supervisor/ResultadosIpv';
import SupervisorGestionarExamen from '../pages/supervisor/GestionarExamen';
import SupervisorPreguntas from '../pages/supervisor/Preguntas';
import SupervisorOpciones from '../pages/supervisor/Opciones';
import SupervisorUsuarios from '../pages/supervisor/Usuarios';
import SupervisorAsignaciones from '../pages/supervisor/Asignaciones';
import PerfilPruebas from '../pages/supervisor/PerfilPruebas';
import ProcesoDetalle from '../pages/supervisor/ProcesoDetalle';

// Postulante Pages
import PostulanteDashboard from '../pages/postulante/Dashboard';
import MisTests from '../pages/postulante/MisTests';
import RealizarTestDisc from '../pages/postulante/RealizarTestDisc';
import RealizarExamenIpv from '../pages/postulante/RealizarExamenIpv';

const AppRouter = () => {
  console.log('AppRouter - JefeSeleccionLayout importado:', JefeSeleccionLayout);
  
  return (
    <Routes>
      {/* Ruta raíz - redirige a login */}
      <Route path="/" element={<Navigate to="/login" replace />} />

      {/* Rutas públicas (solo accesibles si NO está autenticado) */}
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      

      

      

      {/* Rutas de Admin */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute allowedRoles={['ADMIN', 'SISTEMAS']}>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="asignar-postulantes" element={<AsignarPostulantesAdmin />} />
        <Route path="procesos" element={<Procesos />} />
        <Route path="procesos/:id" element={<AdminProcesoDetalle />} />
        <Route path="perfiles" element={<Perfiles />} />
        <Route path="perfil-pruebas" element={<AdminPerfilPruebas />} />
        <Route path="examenes" element={<Examenes />} />
        <Route path="examenes/raven" element={<AdminExamenesRaven />} />
        <Route path="examenes/disc" element={<AdminExamenesDisc />} />
        <Route path="examenes/ipv" element={<AdminExamenesIpv />} />
        <Route path="examenes-ipv/resultados/:evaluacionId" element={<ResultadosIpv />} />
        <Route path="examenes/gestionar/:id" element={<GestionarExamen />} />
        <Route path="preguntas" element={<Preguntas />} />
        <Route path="opciones" element={<Opciones />} />
        <Route path="usuarios" element={<Usuarios />} />
        <Route path="asignaciones" element={<Asignaciones />} />
      </Route>

      {/* Rutas de Supervisor */}
      <Route
        path="/supervisor"
        element={
          <ProtectedRoute allowedRoles={['SUPERVISOR']}>
            <SupervisorLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/supervisor/dashboard" replace />} />
        <Route path="dashboard" element={<SupervisorDashboard />} />
        <Route path="asignar-postulantes" element={<AsignarPostulantes />} />
        <Route path="procesos" element={<SupervisorProcesos />} />
        <Route path="procesos/:id" element={<ProcesoDetalle />} />
        <Route path="perfiles" element={<SupervisorPerfiles />} />
        <Route path="perfil-pruebas" element={<PerfilPruebas />} />
        <Route path="examenes" element={<SupervisorExamenes />} />
        <Route path="examenes/raven" element={<SupervisorExamenesRaven />} />
        <Route path="examenes/disc" element={<SupervisorExamenesDisc />} />
        <Route path="examenes/ipv" element={<SupervisorExamenesIpv />} />
        <Route path="examenes-ipv/resultados/:evaluacionId" element={<SupervisorResultadosIpv />} />
        <Route path="examenes/gestionar/:id" element={<SupervisorGestionarExamen />} />
        <Route path="preguntas" element={<SupervisorPreguntas />} />
        <Route path="opciones" element={<SupervisorOpciones />} />
        <Route path="usuarios" element={<SupervisorUsuarios />} />
        <Route path="asignaciones" element={<SupervisorAsignaciones />} />
      </Route>

      {/* Rutas de Jefe de Selección - Acceso completo igual a Supervisor */}
      <Route
        path="/jefe-seleccion"
        element={
          <ProtectedRoute allowedRoles={['JEFE_SELECCION']}>
            <JefeSeleccionLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/jefe-seleccion/dashboard" replace />} />
        <Route path="dashboard" element={<SupervisorDashboard />} />
        <Route path="asignar-postulantes" element={<AsignarPostulantes />} />
        <Route path="procesos" element={<SupervisorProcesos />} />
        <Route path="procesos/:id" element={<ProcesoDetalle />} />
        <Route path="perfiles" element={<SupervisorPerfiles />} />
        <Route path="perfil-pruebas" element={<PerfilPruebas />} />
        <Route path="examenes" element={<SupervisorExamenes />} />
        <Route path="examenes/raven" element={<SupervisorExamenesRaven />} />
        <Route path="examenes/disc" element={<SupervisorExamenesDisc />} />
        <Route path="examenes/ipv" element={<SupervisorExamenesIpv />} />
        <Route path="examenes-ipv/resultados/:evaluacionId" element={<SupervisorResultadosIpv />} />
        <Route path="examenes/gestionar/:id" element={<SupervisorGestionarExamen />} />
        <Route path="preguntas" element={<SupervisorPreguntas />} />
        <Route path="opciones" element={<SupervisorOpciones />} />
        <Route path="usuarios" element={<SupervisorUsuarios />} />
        <Route path="asignaciones" element={<SupervisorAsignaciones />} />
      </Route>

      {/* Rutas de Analista - Sin dashboard, puede crear pero NO eliminar */}
      <Route
        path="/analista"
        element={
          <ProtectedRoute allowedRoles={['ANALISTA']}>
            <AnalistaLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/analista/procesos" replace />} />
        <Route path="procesos" element={<SupervisorProcesos />} />
        <Route path="procesos/:id" element={<ProcesoDetalle />} />
        <Route path="perfiles" element={<SupervisorPerfiles />} />
        <Route path="perfil-pruebas" element={<PerfilPruebas />} />
        <Route path="examenes" element={<SupervisorExamenes />} />
        <Route path="examenes/raven" element={<SupervisorExamenesRaven />} />
        <Route path="examenes/disc" element={<SupervisorExamenesDisc />} />
        <Route path="examenes/ipv" element={<SupervisorExamenesIpv />} />
        <Route path="examenes-ipv/resultados/:evaluacionId" element={<SupervisorResultadosIpv />} />
        <Route path="examenes/gestionar/:id" element={<SupervisorGestionarExamen />} />
        <Route path="preguntas" element={<SupervisorPreguntas />} />
        <Route path="opciones" element={<SupervisorOpciones />} />
        <Route path="usuarios" element={<SupervisorUsuarios />} />
        <Route path="asignaciones" element={<SupervisorAsignaciones />} />
      </Route>

      {/* Rutas de Reclutador - Solo vista, NO puede eliminar ni crear */}
      <Route
        path="/reclutador"
        element={
          <ProtectedRoute allowedRoles={['RECLUTADOR']}>
            <ReclutadorLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/reclutador/procesos" replace />} />
        <Route path="procesos" element={<SupervisorProcesos />} />
        <Route path="procesos/:id" element={<ProcesoDetalle />} />
        <Route path="perfiles" element={<SupervisorPerfiles />} />
        <Route path="perfil-pruebas" element={<PerfilPruebas />} />
        <Route path="examenes" element={<SupervisorExamenes />} />
        <Route path="examenes/raven" element={<SupervisorExamenesRaven />} />
        <Route path="examenes/disc" element={<SupervisorExamenesDisc />} />
        <Route path="examenes/ipv" element={<SupervisorExamenesIpv />} />
        <Route path="examenes-ipv/resultados/:evaluacionId" element={<SupervisorResultadosIpv />} />
        <Route path="usuarios" element={<SupervisorUsuarios />} />
      </Route>

      {/* Rutas de Postulante */}
      <Route
        path="/postulante"
        element={
          <ProtectedRoute allowedRoles={['POSTULANTE']}>
            <PostulanteLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/postulante/dashboard" replace />} />
        <Route path="dashboard" element={<PostulanteDashboard />} />
        <Route path="tests" element={<MisTests />} />
        <Route path="test-disc/:procesoId/:perfilId" element={<RealizarTestDisc />} />
        <Route path="examen-ipv" element={<RealizarExamenIpv />} />
        <Route path="resultados" element={<div className="text-center text-neutral-600">Página de Resultados (En desarrollo)</div>} />
      </Route>

      {/* Ruta 404 */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};

export default AppRouter;
